import { Component } from "react";
import PropTypes from "prop-types";
import { evalScript } from "../../../utils/misc";

/*
 * How it works
 * -User clicks on ConfirmReservation
 * -Reservation is created on the backend, client gets success answer
 * -Application detects current device (mobile or desktop)
 *   if desktop opens new browser windows with THIS component (special route just for it (a.k.a. WITBOOKING_PAYMENT_ROUTE))
 *   if mobile redirects current window to THIS component
 * -[COMPONENT FLOW A] Component redirects to WitbookingPaymentSystem (a.k.a. PAYMENT_ROUTE)
 *   We must pass Locale / Current Domain / Reservation ID / propertyTicker / Environment(dev, prod)?
 * -User fills CC data in WitbookingPaymentSystem
 * -WitbookingPaymentSystem redirect to either our success or fail state
 * -[COMPONENT FLOW B] If success
 *   if on desktop the browser window is closed (check for window.opener) and the parent is redirected to the confirmation page
 *   if on mobile the (window.opener is null) the component redirect to the confirmation page
 * -[COMPONENT FLOW C] If fail (how?) the user is shown an error message with a button to try again which redirects to WITBOOKING_PAYMENT_ROUTE and start over.
 */
class StripeBridge extends Component {
  constructor(props) {
    super(props);
    this.handler = null;
    this.initialize = this.initialize.bind(this);
    this.startPaymentProcess = this.startPaymentProcess.bind(this);
    this.handlePaymentResponse = this.handlePaymentResponse.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    //TODO: Only load this once
    if (
      this.props.configuration !== prevProps.configuration &&
      typeof this.props.configuration !== "boolean"
    ) {
      evalScript({
        scriptArr: [{ src: "https://checkout.stripe.com/checkout.js" }],
        cb: result => {
          if (result) {
            this.initialize();
          }
        },
      });
    }
  }

  initialize() {
    // TODO: Get Api key from config
    this.handler = window.StripeCheckout.configure({
      key:
        this.props.configuration &&
        this.props.configuration.get("configurationParams").get("publicApiKey"),
      image: "https://stripe.com/img/documentation/checkout/marketplace.png",
      token: this.handlePaymentResponse,
      closed: this.handleClose,
    });
    window.addEventListener("popstate", () => {
      if (this.handler) {
        this.handler.close();
      }
    });
  }

  startPaymentProcess({ name, description, currency, locale, amount, email }) {
    this.handler.open({
      name,
      description,
      currency,
      locale,
      amount,
      email,
    });
  }

  handlePaymentResponse(token, args) {
    this.token = token;
    this.props.onResponse({ token, args });
  }

  handleClose() {
    if (this.token) {
      this.token = null;
      return;
    }
    this.props.onClose();
  }

  render() {
    return null;
  }
}
StripeBridge.propTypes = {
  onInitialize: PropTypes.func,
  onResponse: PropTypes.func,
  onClose: PropTypes.func,
  configuration: PropTypes.object,
};

export default StripeBridge;
